module.exports = __webpack_public_path__ + "static/media/SchoolCosReadinessStep2.2538669f.jpg";